import { useEffect, useRef } from "react";
import maplibregl, { Map as MapLibreMap, Marker } from "maplibre-gl";
import MaplibreWorker from "maplibre-gl/dist/maplibre-gl-csp-worker";
import "maplibre-gl/dist/maplibre-gl.css";
import { CARTO_STYLE_URL } from "./gameStyle";

// Worker CSP forzato (stesso fix di produzione di MapEngine).
try { if (MaplibreWorker) maplibregl.workerClass = MaplibreWorker; } catch (e) { /* noop */ }

// Mini-mappa con pin TRASCINABILE. onChange({lat,lng}) al drag o al click.
export default function PinMap({ lat, lng, onChange, height = 220 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const cbRef = useRef(onChange);
  cbRef.current = onChange;

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    const start = [lng ?? 7.628, lat ?? 45.216];
    const map = new MapLibreMap({ container: ref.current, style: CARTO_STYLE_URL, center: start, zoom: 15, attributionControl: false });
    mapRef.current = map;
    const marker = new Marker({ color: "#00E676", draggable: true }).setLngLat(start).addTo(map);
    markerRef.current = marker;
    const emit = (ll) => cbRef.current && cbRef.current({ lat: +ll.lat.toFixed(6), lng: +ll.lng.toFixed(6) });
    marker.on("dragend", () => emit(marker.getLngLat()));
    map.on("click", (e) => { marker.setLngLat(e.lngLat); emit(e.lngLat); });
    return () => { try { map.remove(); } catch (e) { /* noop */ } mapRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (markerRef.current && lat != null && lng != null) {
      markerRef.current.setLngLat([lng, lat]);
      if (mapRef.current) mapRef.current.setCenter([lng, lat]);
    }
  }, [lat, lng]);

  return <div ref={ref} style={{ height }} className="w-full rounded-xl overflow-hidden border border-white/10" data-testid="pin-map" />;
}
